import terms from "./terms/fr";
import areas from "./areas/fr";
import nogame from "./fr_nogame";

export default {
  translation: {
    nogame: nogame.translation,
    login: {
      title: "Connectez-vous",
      insert:
        "Entrez le code alphanumérique à 10 chiffres qui vous a été fourni:",
      or: "ou",
      qr: "Scannez le code QR",
      qr_back: "Revenir en arrière",
      exit: "Sortie",
      retry: "Quitter",
      failed_1: "L’authentification a échoué.",
      failed_2:
        "Assurez-vous d’avoir bien tapé le jeton en respectant les majuscules et les minuscules.",
      failed_active:
        "Votre jeton n’est pas encore actif. Il le sera à partir de la date suivante:",
      failed_expired: "Votre jeton n’est plus valide.",
      session_warning:
        'Vous avez déjà une session locale ouverte. Pour terminer la session en cours et en démarrer une nouvelle, cliquez sur «FERMER». Sinon, ignorez cet avertissement.',
    },
    footer: {
      help: "À l’aide! Mon code ou QR ne fonctionne pas",
    },
    overlay: {
      close: "FERMER",
      undo: "ANNULER",
      help: "Vous avez besoin d’aide? Envoyez un mail à l’adresse suivante:",
      alert_valid: "Avant de continuer, choisissez une option valable!",
      alert_terms:
        "Avant de procéder, vous devez répondre aux questions concernant vos données personnelles et accepter les conditions générales ! Vérifiez également que vous avez entré les données correctement.",
      confirm_vincolato:
        "Vous êtes sur le point de commencer la partie. Une fois que vous avez cliqué sur OK, vous disposez de 20 minutes pour obtenir le meilleur score. Assurez-vous d’avoir bien lu et compris toutes les instructions. Assurez-vous également d’avoir du temps, une connexion stable et un emplacement confortable et silencieux. Nous vous suggérons de commencer la partie à partir d’un ordinateur équipé d’une souris pour avoir les meilleures conditions de jeu.",
      confirm_libero: "Voulez-vous vraiment quitter le jeu?",
      receive_mail:
        "Entrez votre adresse électronique pour recevoir en format PDF le profil détaillé.",
      receive_mail_placeholder: "Écrivez ici votre e-mail",
      mail_success: "Mail envoyé avec succès!",
      mail_error: "Erreur lors de l’envoi du mail.",
      alert_logout_1:
        "Attention! En quittant, vous ne pourrez plus récupérer votre progression.",
      alert_logout_2: "Si vous souhaitez revenir plus tard, gardez ce lien:",
    },
    user: {
      welcome: "Bienvenue",
      app_description_1: `
        <b>PlayYourJob</b> Il s’agit d’un projet visant à réduire l’écart entre l’offre et la demande de travail, développé et validé par&#32;
        <b>Laborplay</b>, une entreprise dérivée approuvée de
        <b>Université de Florence</b>. En participant au projet, nous vous renverrons le profil de certaines de vos caractéristiques professionnelles.
      `,
      app_description_2: `
        Les activités de <b>Performance</b> ont un temps maximal de 20 minutes. Assurez-vous d’avoir suffisamment de temps pour donner le maximum.
        <br />
        Les activités de <b>Training</b> n’ont pas de temps maximal pour être effectuées et vous pourrez y accéder quand vous le voudrez à différents moments.
      `,
      active_title: "Forfaits actifs",
      loading: "CHARGEMENT EN COURS...",
      confirm: "CONFIRMER ET COMMENCER",
      anagraphics: {
        title: "Questions concernant vos données personnelles",
        description:
          "Remplissez les champs suivants pour effectuer les tâches et enregistrer vos résultats.",
        name: "Prenom",
        name_placeholder: "Saisissez votre prénom",
        surname: "Nom",
        surname_placeholder: "Saisissez votre nom",
        cf: "Numéro de sécurité sociale",
        cf_placeholder: "Saisissez ici votre Code d'identification fiscale",
        email_placeholder: "Saisissez ici votre adresse électronique",
        year: "Année de naissance",
        gender: "Sexe",
        male: "Homme",
        female: "Femme",
        no_gender: "Je préfère ne pas l'indiquer",
        frequency: "Fréquence de jeu",
        never: "Jamais",
        monthly: "Tous les mois",
        weekly: "Toutes les semaines",
        daily: "Tous les jours",
        hourly: "Plusieurs fois par jour",
      },
    },
    games: {
      open: "Ouvrir",
      results: "Résultats",
      title: "Mettez-vous au défi",
      title_libero: "Jeu gratuit",
      close: "Fermer",
      retry: "Réessayer",
      game_order:
        "Avant de pouvoir jouer à ce jeu, vous devez jouer aux précédents.",
      before_rank: "Meilleur du ",
      after_rank: " des joueurs",
      test: "Accéder le test",
    },
    profile: {
      repeat: "Recommencer le test",
      own: "Votre profil PLAY est: ",
      download: "Télécharger le profil",
      title: "Liste des compétences personnelles caractéristiques de ce domaine",
      description:
        "Des scores égaux ou supérieurs à 4 indiquent la présence croissante des capacités suivantes",
      areas,
	},
    pyt: {
      error: "Erreur lors de la récupération des questions.",
      retry: "Réessayer",
      description: `
        <p>
          Le Play Your Test est un questionnaire original développé par Laborplay et validé sur un échantillon de plus de 25 000 personnes. Les questions servent à connaître vos habitudes et préférences de jeu ; vos réponses vous permettent de dresser un profil de vos compétences transversales, ce qui vous aidera à réfléchir à vos points forts et à vos domaines d’amélioration.
        </p>
        <p>
          Le Play Your Test n’est pas seulement destiné aux joueurs ou aux amateurs de jeux de société.
        </p>
        <h4 class="superTitle" className="superTitle">Le Play Your Test est conçu pour tout le monde.</h4>
        <h4>Parce que nous savons tous ce qui nous amuse.</h4>
        <p>
          Répondez en pensant à vos préférences et si vous n’y avez jamais pensé auparavant, c’est le bon moment ! Indiquez ensuite votre degré d’accord avec les affirmations qui vont suivre.
        </p>
      `,
      start: "COMMENCER LE TEST",
      guide: `
        <p>
        Répondez en pensant à vos préférences et si vous n’y avez jamais pensé auparavant, c’est le bon moment ! Indiquez ensuite votre degré d’accord avec les affirmations qui vont suivre. 
        <br />
        <b>QU'AIMEZ-VOUS (OU AIMERIEZ-VOUS) DANS UN JEU ?</b>
        <br />
        <i>1= tout à fait d'accord, 2 = plutôt d'accord, 3 = plutôt en désaccord, 4 = totalement en désaccord</i>
        </p>
      `,
      confirm: "Confirmer",
    },
    profiles: {
      Analitico: "Analytique",
      Attivatore: "Activateur",
      Audace: "Audacieux",
      Brillante: "Brillant",
      Carismatico: "Charismatique",
      Cauto: "Prudent",
      Collaborativo: "Collaboratif",
      Determinato: "Déterminé",
      Disponibile: "Disponible",
      Equilibrato: "Équilibré",
      Influente: "Influent",
      Innovatore: "Innovateur",
      Negoziatore: "Négociateur",
      Riflessivo: "Réfléchi",
      Sistematico: "Systématique",
      Socievole: "Sociable",
      Vivace: "Vivant",
    },
    terms,
  },
};
